// src/components/profile-details.component.tsx
import React from 'react';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { iProfile } from '../interfaces/profile.interface';

interface ProfileDetailsProps {
    profile: iProfile | null;
}

const ProfileDetails: React.FC<ProfileDetailsProps> = ({ profile }) => {
    if (!profile) {
        return <Alert variant="warning">No profile data available.</Alert>;
    }

    const formatPhoneNumber = (phone: string) => {
        // Remove any non-numeric characters
        const cleaned = phone.replace(/\D/g, '');

        // Apply format if it has at least 10 digits
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
        }
        return phone; //Returns the original number if it is not 10 digits
    };


    return (
        <Card className="shadow-sm">
            <Card.Body>
                <Row className="mb-4">
                    <Col xs={12}>
                        <h4 className="greenColour">{profile.firstName} {profile.lastName}</h4>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>City:</strong></Col>
                    <Col xs={6} className="text-end">{profile.city}</Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>State:</strong></Col>
                    <Col xs={6} className="text-end">{profile.state}</Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={12}>
                        <h4 className="">Contact</h4>
                        <hr />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Email:</strong></Col>
                    <Col xs={6} className="text-end">{profile.email}</Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Phone:</strong></Col>
                    <Col xs={6} className="text-end">{formatPhoneNumber(profile.phone)}</Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Address:</strong></Col>
                    <Col xs={6} className="text-end">{profile.address}</Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={12}>
                        <h4 className="">Employment</h4>
                        <hr />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Working For:</strong></Col>
                    <Col xs={6} className="text-end">{profile.workFor}</Col>
                </Row>

            </Card.Body>
        </Card>
    );
};

export default ProfileDetails;